declare global {
  interface Window {
    dataLayer?: IArguments[];
    gtag?: (...args: unknown[]) => void;
  }
}

function analyticsUrl(location: string) {
  if (!location) return '';
  const url = new URL(location);
  url.searchParams.delete('request_token');
  url.searchParams.delete('approved');
  return url.toString();
}

export function initializeAnalytics(measurementId: string | undefined, environment: string) {
  if (!measurementId || environment !== 'production') return;
  window.dataLayer = [];
  window.gtag = function () {
    // eslint-disable-next-line prefer-rest-params -- Google's tag loader expects an arguments object.
    window.dataLayer!.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', measurementId, {
    send_page_view: false,
    page_location: analyticsUrl(window.location.href),
    page_referrer: analyticsUrl(document.referrer),
  });
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  document.head.appendChild(script);
}

export function trackPageView(location: string) {
  window.gtag?.('event', 'page_view', {
    page_location: analyticsUrl(location),
    page_title: document.title,
    page_referrer: analyticsUrl(document.referrer),
  });
}
